import React, { useEffect, useState } from 'react'
import Option from 'app/React/Components/Form/Option'
import Tip from 'app/React/Components/misc/Tip'
import clx from 'classnames'
import { FeatureFlag } from 'utils/feature-flag'

export default function Setting(props) {
  const {
    order,
  } = useContext(ConfiguratorContext)

  const setting = props.setting
  const options = Array.isArray(setting.options) ? { ...setting.options } : setting.options

  const optionValues = Object.values(options)

  const [checked, setChecked] = useState(
    typeof order.configuration[setting.id] === 'object' ? order.configuration[setting.id].id : null
  )

  useEffect(() => {
    setChecked(typeof order.configuration[setting.id] === 'object' ? order.configuration[setting.id].id : null)
  }, [order.configuration, setting.id])


  const option_elements = Object.keys(options).map((key) => (
    <Option
      key={key}
      option={options[key]}
      layout={setting.layout}
      settingid={setting.id}
      onChange={props.onChange}
      checked={checked}
      setChecked={setChecked}
      required={setting.required && setting.required !== '0'}
      hidePrice={props.hidePrice}
    />
  ))

  if (
    optionValues.filter(
      (o) =>
        !(
          o.hide_on === order.paymentType ||
          o.hide_on === 'all' ||
          (!FeatureFlag.accessoryShop() && o.type === 'accessory-product')
        )
    ).length <= 0
  ) {
    return null
  }

  return (
    <>
      <div className={clx('setting', props.className)} data-setting-id={setting.id}>
        <h3 className='config-subtitle'>
          {setting.label}
          {typeof setting.description === 'string' && setting.description.length > 0 ? (
            <Tip button='Ok' content={setting.description}/>
          ) : null}
        </h3>
        <div className='config-radio' data-option-count={option_elements.length}>
          {option_elements}
        </div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}

Setting.defaultProps = {
  onChange: null,
  className: '',
  hidePrice: false
}
